<template>
  <div class="avatar">
        <div class="avatar-image">
            <hsimage class="avatar-image"  :src="url"></hsimage>
        </div>
        <div class="avatar-text">{{text}}</div>
    </div>
</template>

<script>
import hsimage from '../common/hsimage.vue'

export default {
    name:'Avatar',
    props:{
        name: String,
        url:String
    },
    components:{
        hsimage
    },
    data(){
        return {
            avatar_defalut:"",
            text:''
        }
    },
    mounted(){
        this.text = this.name
    },
    watch:{
        name:{
            handlers(newval,oldval){
                this.text = newval
            }
        },
        url: {
            handler(newval,oldval){
                this.avatar_defalut = newval
            }
        }
    }
    
}
</script>

<style scoped>
    .avatar{

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .avatar-image{
        width: 84px;
        height: 84px;
        border-radius: 42px;
        background-color: antiquewhite;
    }
    .avatar-text{
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/avatar_card.vue